module.exports = require("v-tooltip");